'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ROLLBAR_LEVELS = exports.ROLLBAR_LEVELS = {
    CRITICAL: 'critical',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    DEBUG: 'debug'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/rollbarConstants.js
// module id = 420
// module chunks = 0